<template>
  <DialogoFormulario
    ref="dialog"
    title="Adicionar local de estoque"
    :width="400"
    :handler="handler"
  >
    <template v-slot="{ form, errors }">
      <CampoSeletorCliente
        v-model="form.cliente"
        label="Cliente"
        outlined
        :error-messages="errors.cliente"
      ></CampoSeletorCliente>
      <CampoSeletorEndereco
        v-model="form.endereco"
        :cliente-id="form.cliente ? form.cliente.id : null"
        label="Endereço"
        outlined
        :error-messages="errors.endereco"
      ></CampoSeletorEndereco>
      <v-text-field
        v-model="form.nome"
        label="Nome (opcional)"
        outlined
        hint="Deixar em branco para que o sistema gere automaticamente"
      ></v-text-field>
    </template>
  </DialogoFormulario>
</template>

<script>
import DialogoFormulario from "@/components/dialogos/DialogoFormulario.vue";
import CampoSeletorCliente from "@/components/clientes/CampoSeletorCliente.vue";
import CampoSeletorEndereco from "@/components/clientes/CampoSeletorEndereco.vue";
import alerts from "@/mixins/alerts";
import locacoes from "@/services/locacoes";

export default {
  mixins: [alerts],

  components: {
    DialogoFormulario,
    CampoSeletorCliente,
    CampoSeletorEndereco
  },

  props: {},

  data() {
    return {};
  },

  methods: {
    open(inicial) {
      this.$refs.dialog.open(inicial);
    },

    async handler(form) {
      try {
        const response = await locacoes.locais_de_estoque.adicionar({
          cliente_id: form.cliente.id,
          endereco_id: form.endereco.id,
          nome: form.nome
        });

        this.$emit("adicionado", response);
        this.alert("Local de estoque adicionado");
      } catch (error) {
        console.error(error);
        this.error("Não foi possível adicionar local de estoque");
      }
    }
  },

  computed: {}
};
</script>
